// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"950d3b62","239":"dc5382af","455":"9f97e9f8"}[chunkId] + ".chunk.js";
};